import React from 'react';
import DepartmentTemplate from './DepartmentTemplate';

const DeptSeineEtMarne77 = () => {
  return (
    <DepartmentTemplate
      department="Seine-et-Marne"
      departmentNumber="77"
      cities="Meaux, Melun, Chelles, Pontault-Combault, Savigny-le-Temple, Fontainebleau"
      region="Île-de-France"
    />
  );
};

export default DeptSeineEtMarne77;
